/* eslint-disable camelcase */
import { Visit } from '~/types/visits';
import { WeekPlanner } from './WeekPlanner/WeekPlanner';
import './VisitsInfo.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '@abm-international/react-components';
import {
	faEnvelope, faCopy, faEdit, faTimes, faCheck,
	faPhone
} from '@fortawesome/free-solid-svg-icons';
import { MouseEvent, useEffect, useState } from 'react';
import { formatCurrency } from '../Visits';
import Api, { comocatOrder, upsertCustomerNote } from '../../../libraries/api';
import api from '../../../libraries/api';
import { tLocal } from '../../../libraries/i18nLocal';

interface VisitsInfoProps {
    visit?: Visit;
}

export const VisitsInfo = (props: VisitsInfoProps) => {
	const { visit } = props;
	const [copiedField, setCopiedField] = useState<string | null>(null);
	const [comment, setComment] = useState(visit?.notes || '');
	const [commentDisabled, setCommentDisabled] = useState(true);
	const [customerDMZInfo, setCustomerDMZInfo] = useState<any[] | null>(null);
	const onCancel = () => {
		setCommentDisabled(prev => {
			if (!prev) {
				setComment(visit?.notes || '');
			}
			return !prev;

		});
	};



	async function fetchCustomerDMZInfo() {

		return api.getComocatDMZCustomerInfo(visit?.id || '')
			.then(data => {
				setCustomerDMZInfo(data || []);
			})
			.catch(() => {
				setCustomerDMZInfo(null);
			});
	}

	useEffect(() => {
		fetchCustomerDMZInfo();
	}, []);

	const loginComocatToVacationDays = async (e: MouseEvent<HTMLButtonElement>, visit: Visit) => {
		//dispatch(appNavigationToggleCollapse(false));
		e.stopPropagation();
		await Api.setCustomer(visit.id, visit);
		await comocatOrder(true);
		window.document.location = '/settings/vacation';
	};

	const onSave = async () => {
		await upsertCustomerNote(visit?.id, { note: comment });
		setCommentDisabled(true);
		if (visit) {
			visit.notes = comment;
		}
	};

	// useEffect(() => {
	// 	setComment(visit?.notes || '');
	// }, [visit]);

	if (!visit) return null;

	const {
		id, name, dem_nam, dem_tl1, dem_tl2, mail, klantTblAdress, address, deliveryDays, closingDays, notes, vacationDays, customerReference, saldo
	} = visit;

	// Helper for formatting numbers
	function format_number(value: any, decimals = 0, decPoint = '', thousandsSep = '') {
		if (value === null || value === undefined || isNaN(Number(value))) return '';
		let n = Number(value).toFixed(decimals);
		if (thousandsSep) {
			n = n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
		}
		if (decPoint && decimals > 0) {
			n = n.replace('.', decPoint);
		}
		return n;
	}

	 return (
	 	<div className='VisitsInfo'>
	 		<h3>{id} - {name}</h3>
	 		<div style={{
	 			display: 'flex', flexDirection: 'column', gap: '0.6rem', color: '#1C9464'
	 		}}>

				{customerDMZInfo === null ? (
					<div style={{
						display: 'flex', alignItems: 'center', gap: 8, color: '#888', fontSize: '1.1em', flexDirection: 'column'
					}}>
						<Spinner size="small" />
						<span>{tLocal('comocat.visits_info.loading_contact')}</span>
					</div>
				) : (
					['boekhouding', 'prijswijziging', 'marketing'].map((key:any) => {
						const info = customerDMZInfo[key];
						if (!info) return null;
						const handleCopy = (field: string, value: string) => {
							navigator.clipboard.writeText(value);
							setCopiedField(`${key}-${field}`);
							setTimeout(() => setCopiedField(null), 1200);
						};
						return (
							<div
								key={key}
								className={`dmzinfo-row dmzinfo-row-${key} dmzinfo-row-highlight`}
							>
								<strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
								{info.telefoon1 && (
									<span
										style={{ marginLeft: 8, cursor: 'pointer', color: copiedField === `${key}-telefoon1` ? '#5285e4' : undefined }}
										title={copiedField === `${key}-telefoon1`
											? tLocal('comocat.visits_info.copied')
											: tLocal('comocat.visits_info.copy_hint')}
										onClick={() => handleCopy('telefoon1', info.telefoon1)}
									>
										<FontAwesomeIcon icon={faPhone} /> {info.telefoon1}
										{copiedField === `${key}-telefoon1` && <FontAwesomeIcon icon={faCopy} style={{ marginLeft: 4, color: '#5285e4' }} />}
									</span>
								)}
								{info.telefoon2 && (
									<span
										style={{ marginLeft: 8, cursor: 'pointer', color: copiedField === `${key}-telefoon2` ? '#5285e4' : undefined }}
										title={copiedField === `${key}-telefoon2`
											? tLocal('comocat.visits_info.copied')
											: tLocal('comocat.visits_info.copy_hint')}
										onClick={() => handleCopy('telefoon2', info.telefoon2)}
									>
										<FontAwesomeIcon icon={faPhone} /> {info.telefoon2}
										{copiedField === `${key}-telefoon2` && <FontAwesomeIcon icon={faCopy} style={{ marginLeft: 4, color: '#5285e4' }} />}
									</span>
								)}
								{info.email && (
									<span
										style={{ marginLeft: 8, cursor: 'pointer', color: copiedField === `${key}-email` ? '#5285e4' : undefined }}
										title={copiedField === `${key}-email`
											? tLocal('comocat.visits_info.copied')
											: tLocal('comocat.visits_info.copy_hint')}
										onClick={() => handleCopy('email', info.email?.toLowerCase())}
									>
										<FontAwesomeIcon icon={faEnvelope} /> {info.email?.toLowerCase()}
										{copiedField === `${key}-email` && <FontAwesomeIcon icon={faCopy} style={{ marginLeft: 4, color: '#5285e4' }} />}
									</span>
								)}
							</div>
						);
					})
				)}
			</div>

			<div className='split-block'>
				<div className='facturatie'>
					<h4>{tLocal('comocat.visits_info.section_billing')}</h4>
					<p dangerouslySetInnerHTML={{
						__html: [
							dem_nam && `<b>${dem_nam}</b>`,
							klantTblAdress.klt_adr,
                            `${klantTblAdress.klt_pst} ${klantTblAdress.klt_gem}`,
                            dem_tl1 && `Tel: ${dem_tl1}`
						].filter(Boolean).join('<br />')
					}} />
				</div>

				<div className='levering'>
					<h4>{tLocal('comocat.visits_info.section_delivery')}</h4>
					<p dangerouslySetInnerHTML={{
						__html: [
							`<b>${name}</b>`,
							address.street,
                            `${address.postalCode} ${address.city}`,
                            dem_tl2 && `Tel: ${dem_tl2}`
						].filter(Boolean).join('<br />')
					}} />
				</div>
			</div>

			<div className='split-block'>
				<div className='week'>
					<h4>{tLocal('comocat.visits_info.section_opening_days')}</h4>
					<WeekPlanner closed={closingDays} />
				</div>

				<div className='week'>
					<h4>{tLocal('comocat.visits_info.section_delivery_days')}</h4>
					<WeekPlanner days={deliveryDays.allDeliveryDays} active={deliveryDays.mainDeliveryDay} />
				</div>
			</div>

			<div className='week' style={{ width: '100%' }}>
				<h4>{tLocal('comocat.visits_info.section_vacation')}</h4>
				<p>{vacationDays.start && vacationDays.end ? `${(new Date(vacationDays.start).toLocaleDateString())} - ${(new Date(vacationDays.end).toLocaleDateString())}` : tLocal('comocat.visits_info.no_vacation')}</p>
				<div className="visitsinfo-btn-row" style={{ justifyContent: 'flex-end' }}>
					<button
                        	className="visitsinfo-btn visitsinfo-btn-edit"
                        	type="button"
                        	onClick={(e: MouseEvent<HTMLButtonElement>) => loginComocatToVacationDays(e, visit)}
					>
                        	<FontAwesomeIcon icon={faEdit} /> {tLocal('comocat.visits_info.btn_add_vacation')}
					</button>
				</div>
			</div>

			<div className='notes' style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
				<div>
					<h4>{tLocal('comocat.visits_info.section_notes')}</h4>
				</div>
				<div>
					<textarea id="extra-notities" style={{
						fontSize: '1.2rem', minHeight: '10rem', marginBottom: '1rem', width: '100%', borderRadius: '8px', border: '1px solid #ccc', padding: '0.5rem'
					}} disabled={commentDisabled} value={comment} onChange={(e) => { e.preventDefault(); e.stopPropagation(); setComment(e.target.value); }} />
					{!!visit &&
                    <div className="visitsinfo-btn-row">
                    	{commentDisabled ? (
                        <button
                        	className="visitsinfo-btn visitsinfo-btn-edit"
                        	type="button"
                        	onClick={onCancel}
                        >
                        	<FontAwesomeIcon icon={faEdit} /> {tLocal('comocat.visits_info.btn_edit')}
                        </button>
                        ) : (
                        <>
                        	<button
                        		className="visitsinfo-btn visitsinfo-btn-cancel"
                        		type="button"
                        		onClick={onCancel}
                        	>
                        		<FontAwesomeIcon icon={faTimes} /> {tLocal('comocat.visits_info.btn_cancel')}
                        	</button>
                        	<button
                        		className="visitsinfo-btn visitsinfo-btn-save"
                        		type="button"
                        		onClick={onSave}
                        		disabled={commentDisabled}
                        	>
                        		<FontAwesomeIcon icon={faCheck} /> {tLocal('comocat.visits_info.btn_save')}
                        	</button>
                        </>
                        )}
                    </div>}
				</div>
			</div>
			<div className='split-block'>
				<div className='customer-reference'>
					<h4>{tLocal('comocat.visits_info.section_customer_ref')}</h4>
					<p>{
					customerReference
						? `EUR/K${
						  customerReference.klt_kat || '' }/${
						  customerReference.klt_tst || '' }/${
						  customerReference.cro_lev || '' }/${
						  format_number(customerReference.klt_gemwkver, 0, '', '')
						  }${(customerReference.klt_pfa && customerReference.klt_pfa > 0 )? `F${customerReference.klt_pfa}` : ''}`
						: '-'
					}</p>
				</div>
				<div className='saldo'>
					<h4>{tLocal('comocat.visits_info.section_balance')}</h4>
					<p>{formatCurrency(saldo)}</p>
				</div>
			</div>
		</div>
	);
};
